export const KEYWORDS_DETAILS_SECTION_I18N_PREFIX = "features.topics.components.edit_topic.keywords_details_section";

export const KEYWORDS_DETAILS_SECTION_I18N_KEYS = {
  keywords_details_section_title:      "keywords_details_section_title",
  no_keywords_for_topic_message:       "no_keywords_for_topic_message",
  any_of_these_keywords:               "any_of_these_keywords",
  and_any_of_these_keywords:           "and_any_of_these_keywords",
  none_of_these_keywords:              "none_of_these_keywords",
  no_keywords_in_section_default_text: "no_keywords_in_section_default_text",
  earliest_historical_data_date:       "earliest_historical_data_date"
};


// WEBPACK FOOTER //
// ./src/features/topics/components/edit-topic/constants/i18n/KeywordsDetailsSectioni18nConstants.js